import { Suspense } from 'react'
import { Outlet } from 'react-router-dom'
import { GlobalModal } from '../setup/context/GlobalModal'
import { I18nProvider } from '../_metronic/i18n/i18nProvider'
import { LayoutProvider, LayoutSplashScreen } from '../_metronic/layout/core'
import { MasterInit } from '../_metronic/layout/MasterInit'

import AuthInit from './modules/auth/redux/AuthInit'
const App = () => {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
        <GlobalModal>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </LayoutProvider>
        </GlobalModal>
      </I18nProvider>
    </Suspense>
  )
}

export { App }
